export default "__VITE_ASSET__foDCXBop__"